import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SpaceBarIcon(props: IconProps) {
    return <Icon {...props} iconKey={"space_bar"}/>
}
